import React from 'react'

const DownloadWhiteSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 18.203 18.048'
    >
      <g
        id='download-svgrepo-com_1_'
        data-name='download-svgrepo-com (1)'
        transform='translate(0 -2.188)'
      >
        <path
          id='Path_3023'
          data-name='Path 3023'
          d='M107.581,13.651a1.279,1.279,0,0,0,1.81,0l4.159-4.158a1.28,1.28,0,0,0-1.81-1.81h0l-1.974,1.974V3.468a1.28,1.28,0,1,0-2.56,0V9.656l-1.973-1.973a1.28,1.28,0,1,0-1.81,1.81Z'
          transform='translate(-99.384)'
          fill='#fff'
        />
        <path
          id='Path_3024'
          data-name='Path 3024'
          d='M16.833,383.148H11.854a3.019,3.019,0,0,1-5.5,0H1.371A1.371,1.371,0,0,0,0,384.519v1.762a1.371,1.371,0,0,0,1.371,1.371H16.833a1.37,1.37,0,0,0,1.37-1.371v-1.762A1.37,1.37,0,0,0,16.833,383.148Z'
          transform='translate(0 -367.415)'
          fill='#fff'
        />
      </g>
    </svg>
  )
}

export default DownloadWhiteSvg
